import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import { useParams, Link, useNavigate } from "react-router-dom";
import {MatEditor} from "maticzeditor"
import isEmpty from '../../lib/isEmpty';
import { getcms1, updatecms1 } from '../../actions/users';
import { toastAlert } from '../../lib/toastAlert';

const MidNewedit = () => {
  const { Id } = useParams();
  const navigate = useNavigate()

  const [validateError, setValidateError] = useState({});
  const [answer, setanswer] = useState("");
  const [question, setquestion] = useState("");

  useEffect(()=>{
    getCMSData()
  },[])

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    let reqData = {
      question,
      answer,
      Id,
    };
    let { error } = await updatecms1(reqData);
    if (isEmpty(error)) {
      toastAlert("success", "CMS updated successfully");
      navigate("/cmslist");
    } else {
      setValidateError(error);
    }
  };

  const getCMSData = async () => {
    var test = await getcms1(Id);
    if (test.Success) {
      if (test.userValue.question) {
        setquestion(test.userValue.question);
      }
      if (test.userValue.answer) {
        setanswer(test.userValue.answer);
      }
    }
  };

  const onEditorChange = (e) => {
    var description_text = e;
    setanswer(description_text);
  };

  return (
    <>
      <Container fluid className="common_bg position-relative">
        <div className="liner"></div>
        <Row>
          <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
            <Sidebar />
          </Col>
          <Col xl={10} lg={12}>
            <Header title={'Edit CMS'} />
            <div className='common_page_scroller mt-5 pe-2'>
            <button className='btn addcate' onClick={()=>navigate(-1)}>Back</button>

              <form noValidate onSubmit={handleFormSubmit}>
              <div className="addcategorys mb-4">
                  <h4>Edit CMS</h4>
                </div>
                <div>
                  <div>
                    <MatEditor sendata={answer} outdata={(evt) => onEditorChange(evt)} />
                    {validateError.answer && (
                      <span className="text-danger">{validateError.answer}</span>
                    )}
                  </div>
                </div>
                <div>
                  <button className='btn addcate mt-3 mb-4 ms-2' type="submit">Update</button>
                </div>
              </form>

            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default MidNewedit